var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EEF4FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4945_21904",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4945_21904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.44405 18.4001V16.9779H11.2885V14.7734C10.7078 14.6431 10.1892 14.3971 9.73294 14.0357C9.27665 13.6742 8.94183 13.2208 8.7285 12.6757C7.83961 12.569 7.09591 12.1808 6.49739 11.5112C5.89887 10.8416 5.59961 10.0564 5.59961 9.15565V8.44454C5.59961 8.05343 5.73887 7.71862 6.01739 7.4401C6.29591 7.16158 6.63072 7.02232 7.02183 7.02232H8.44405V5.6001H15.5552V7.02232H16.9774C17.3685 7.02232 17.7033 7.16158 17.9818 7.4401C18.2604 7.71862 18.3996 8.05343 18.3996 8.44454V9.15565C18.3996 10.0564 18.1004 10.8416 17.5018 11.5112C16.9033 12.1808 16.1596 12.569 15.2707 12.6757C15.0574 13.2208 14.7226 13.6742 14.2663 14.0357C13.81 14.3971 13.2915 14.6431 12.7107 14.7734V16.9779H15.5552V18.4001H8.44405ZM8.44405 11.1468V8.44454H7.02183V9.15565C7.02183 9.60602 7.1522 10.0119 7.41294 10.3734C7.67368 10.7349 8.01739 10.9927 8.44405 11.1468ZM11.9996 13.4223C12.5922 13.4223 13.0959 13.2149 13.5107 12.8001C13.9255 12.3853 14.1329 11.8816 14.1329 11.289V7.02232H9.86628V11.289C9.86628 11.8816 10.0737 12.3853 10.4885 12.8001C10.9033 13.2149 11.407 13.4223 11.9996 13.4223ZM15.5552 11.1468C15.9818 10.9927 16.3255 10.7349 16.5863 10.3734C16.847 10.0119 16.9774 9.60602 16.9774 9.15565V8.44454H15.5552V11.1468Z",
    fill: "#004AF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.da6f560b6178d0cb8c601efb4f33ff06.svg";
export { ForwardRef as ReactComponent };